import { WelcomeH3 } from "./SectionShell"

export function WelcomeNotificationChart() {
  return (
    <div className="mt-6">
      <WelcomeH3>Veja como as notificações são enviadas</WelcomeH3>

      <p className="mt-1 text-sm leading-relaxed text-slate-600">
        Compare os canais mais usados pelo governo
      </p>

      <div className="mt-2 overflow-x-auto rounded-[6px] border border-slate-300 bg-white p-3">
        <div className="min-w-[640px]">
          <svg
            viewBox="0 0 760 260"
            className="h-[210px] w-full"
            role="img"
            aria-label="Gráfico de canais de notificação"
          >
            <rect x="0" y="0" width="760" height="260" fill="white" />
            <text
              x="20"
              y="22"
              fontSize="12"
              fill="#64748b"
              fontFamily="Montserrat, system-ui, -apple-system, Segoe UI, sans-serif"
              fontWeight="600"
            >
              A maior parte das notificações é enviada por push, mostrando que o
              governo prioriza comunicação rápida.
            </text>

            <g transform="translate(70,55)">
              <g stroke="#e2e8f0" strokeWidth="1">
                <line x1="0" y1="0" x2="640" y2="0" />
                <line x1="0" y1="40" x2="640" y2="40" />
                <line x1="0" y1="80" x2="640" y2="80" />
                <line x1="0" y1="120" x2="640" y2="120" />
                <line x1="0" y1="160" x2="640" y2="160" />
                <line x1="0" y1="200" x2="640" y2="200" />
                <line x1="0" y1="0" x2="0" y2="200" />
                <line x1="160" y1="0" x2="160" y2="200" />
                <line x1="320" y1="0" x2="320" y2="200" />
                <line x1="480" y1="0" x2="480" y2="200" />
                <line x1="640" y1="0" x2="640" y2="200" />
              </g>

              <g
                fontSize="10"
                fill="#64748b"
                fontFamily="Montserrat, system-ui, -apple-system, Segoe UI, sans-serif"
              >
                <text x="-10" y="18" textAnchor="end">
                  Aplicativo <br /> (Contracheque)
                </text>
                <text x="-10" y="58" textAnchor="end">
                  Aplicativo (Aniversário)
                </text>
                <text x="-10" y="98" textAnchor="end">
                  WhatsApp
                </text>
                <text x="-10" y="138" textAnchor="end">
                  Portal
                </text>
                <text x="-10" y="178" textAnchor="end">
                  E-mail
                </text>
              </g>

              <rect x="0" y="4" width="590" height="28" rx="2" fill="#0b4f93" />
              <rect
                x="0"
                y="44"
                width="420"
                height="28"
                rx="2"
                fill="#1f9aa6"
              />
              <rect
                x="0"
                y="84"
                width="180"
                height="28"
                rx="2"
                fill="#1f8f4a"
              />
              <rect
                x="0"
                y="124"
                width="55"
                height="28"
                rx="2"
                fill="#f2b100"
              />
              <rect
                x="0"
                y="164"
                width="40"
                height="28"
                rx="2"
                fill="#10b7d6"
              />

              <g
                fontSize="10"
                fill="#64748b"
                fontFamily="Montserrat, system-ui, -apple-system, Segoe UI, sans-serif"
              >
                <text x="0" y="225">
                  0
                </text>
                <text x="150" y="225">
                  2000
                </text>
                <text x="310" y="225">
                  4000
                </text>
                <text x="470" y="225">
                  6000
                </text>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}
